import Vue from "vue"
import App from "./App"
import router from "./router"
import axios from "axios"
import ElementUI from "element-ui"
import "element-ui/lib/theme-chalk/index.css"
import "./assets/icon/iconfont.css"
import VueAwesomeSwiper from "vue-awesome-swiper"
import "swiper/dist/css/swiper.css"
// import 'default-passive-events'
// import FileSaver from 'file-saver'
// import XLSX from 'xlsx'
import dataV from "@jiaminghi/data-view" //大屏展示 Ui框架


Vue.config.productionTip = false;
Vue.use(ElementUI);
Vue.use(dataV)
Vue.use(VueAwesomeSwiper);
// Vue.use(FileSaver);
// Vue.use(XLSX);

Vue.prototype.$getUrlParams = (name) => {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg); //获取url中"?"符后的字符串并正则匹配
    var context = "";
    if (r != null)
        context = decodeURIComponent(r[2]);
    reg = null;
    r = null;
    return context == null || context == "" || context == "undefined" ? "" : context;
}

// 修改原型链,其它地方可以直接使用this.$axios
Vue.prototype.$axios = axios;
// 多个接口错误提醒只出现一个
let messageInstance = null;
const resetMessage = (options) => {
    if (messageInstance) {
        messageInstance.close()
    }
    messageInstance = ElementUI.Message(options)
}
/* axios拦截器 */
// http request 请求拦截器，有token值则配置上token值

// axios.defaults.baseURL = "http://192.169.3.3:9000";
axios.interceptors.request.use(
    config => {
        if (localStorage.token) { // 每次发送请求之前判断是否存在token，如果存在，则统一在http请求的header都加上token，不用每次请求都手动添加了
            config.headers.token = localStorage.token;
        }
        // if (config.url.indexOf("api") !== -1) { // 为了舍弃代理的问题
        //     config.url = config.url.replace("/api", "").replace("api", "")
        // }
        return config;
    },
    err => {
        return Promise.reject(err);
    }
);
// http response 服务器响应拦截器
axios.interceptors.response.use(
    response => {
        return response
    },
    /*新增错误拦截-cb*/
    error => {
        if (error.response.data.status === 401) {
            resetMessage({
                message: "当前账号暂无此功能权限",
                type: "error"
            })
        } else if (error.response.data.status === 504) {
            resetMessage({
                message: "登录失效，请重新登录",
                type: "error"
            })
            router.push({ path: "/", query: { projectCode: localStorage.getItem("projectCode") } });
        } else if (error.response.data.status !== 200) {
            resetMessage({
                message: error.response.data.message,
                type: "error"
            })
        }
        return Promise.reject(error.response.status) // 返回接口错误信息
    }
);


Date.prototype.format = function(format) {
    var o = {
        "M+": this.getMonth() + 1, //month
        "d+": this.getDate(),    //day
        "h+": this.getHours(),   //hour
        "m+": this.getMinutes(), //minute
        "s+": this.getSeconds(), //second
        "q+": Math.floor((this.getMonth() + 3) / 3),  //quarter
        "S": this.getMilliseconds() //millisecond
    };
    if (/(y+)/.test(format)) format = format.replace(RegExp.$1,
        (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    for (var k in o) if (new RegExp("(" + k + ")").test(format))
        format = format.replace(RegExp.$1,
            RegExp.$1.length == 1 ? o[k] :
                ("00" + o[k]).substr(("" + o[k]).length));
    return format;
};


new Vue({
    el: "#app",
    router,
    components: { App },
    template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js